var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingRelease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.773,
    height: 37.314,
    viewBox: "0 0 31.773 37.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pending_Release",
    "data-name": "Pending Release",
    transform: "translate(-639.227 -245.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "launch-svgrepo-com",
    transform: "translate(632.117 238.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M14,26.265l6.056,6.085s18.873-8.007,17.86-24.185C37.917,8.165,22.944,5.911,14,26.265Z",
    transform: "translate(-2.522)",
    fill: "none",
    stroke: "#878a99",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M44.69,9.09a7.138,7.138,0,0,0,5.993,5.862",
    transform: "translate(-15.66 -0.428)",
    fill: "none",
    stroke: "#878a99",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3.546,
    cy: 3.546,
    r: 3.546,
    transform: "translate(22.493 13.964)",
    fill: "none",
    stroke: "#878a99",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M12.493,32.854l-3.031.389a.154.154,0,0,1-.16-.212l2.248-5.147a1.516,1.516,0,0,1,1.075-.875l3.769-.789",
    transform: "translate(-0.505 -7.761)",
    fill: "none",
    stroke: "#878a99",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M26.254,46.48l-.395,3.031a.154.154,0,0,0,.212.16l5.147-2.242a1.538,1.538,0,0,0,.875-1.081l.789-3.769",
    transform: "translate(-7.598 -14.765)",
    fill: "none",
    stroke: "#878a99",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M16.174,45.364C14.818,49.6,8.11,49.814,8.11,49.814s-.063-6.52,4.375-8.144",
    transform: "translate(0 -14.376)",
    fill: "none",
    stroke: "#878a99",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_info_24px",
    transform: "translate(649 261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,15H11V11h2Zm0-8H11V7h2Z",
    fill: "#878a99"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingRelease);
export default __webpack_public_path__ + "static/media/Pending_Release.c33d6efa00986b4d296b4396d78ee7bf.svg";
export { ForwardRef as ReactComponent };